import './AboutContent_WorkExp.css';
import '../../../css/General.css';
import {useEffect, useRef, useState, useMemo} from 'react';

export const AboutContent_WorkExp = (props) =>{

  const language = localStorage.getItem('language') || 'pt';
    const sufixo = props.minimapa ? "s":"r";

    const ref99 = useRef(null); //title

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);
    const ref8 = useRef(null);
    const ref9 = useRef(null);
    const ref10 = useRef(null);
    const ref11 = useRef(null);
    const ref12 = useRef(null);
    const ref13 = useRef(null);
    const ref14 = useRef(null);
    const ref15 = useRef(null);
    const ref16 = useRef(null);
    const ref17 = useRef(null);
    const ref18 = useRef(null);
    const ref19 = useRef(null);
    const ref20 = useRef(null);
    const ref21 = useRef(null);
    const ref22 = useRef(null);
    const ref23 = useRef(null);
    const ref24 = useRef(null);
    const ref25 = useRef(null);
    const ref26 = useRef(null);
    const ref27 = useRef(null);
    const ref28 = useRef(null);
    const ref29 = useRef(null);

    useIsInViewport(ref99); //title

    useIsInViewport(ref1);
    useIsInViewport(ref2);
    useIsInViewport(ref3);
    useIsInViewport(ref4);
    useIsInViewport(ref5);
    useIsInViewport(ref6);
    useIsInViewport(ref7);
    useIsInViewport(ref8);
    useIsInViewport(ref9);
    useIsInViewport(ref10);
    useIsInViewport(ref11);
    useIsInViewport(ref12);
    useIsInViewport(ref13);
    useIsInViewport(ref14);
    useIsInViewport(ref15);
    useIsInViewport(ref16);
    useIsInViewport(ref17);
    useIsInViewport(ref18);
    useIsInViewport(ref19);
    useIsInViewport(ref20);
    useIsInViewport(ref21);
    useIsInViewport(ref22);
    useIsInViewport(ref23);
    useIsInViewport(ref24);
    useIsInViewport(ref25);
    useIsInViewport(ref26);
    useIsInViewport(ref27);
    useIsInViewport(ref28);
    useIsInViewport(ref29);

    function useIsInViewport(ref) {
        const [isIntersecting, setIsIntersecting] = useState(false);
      
        const observer = useMemo(
          () =>
            new IntersectionObserver(([entry]) =>
              setIsIntersecting(sufixo == "r" && entry.isIntersecting),
            ),
          [],
        );
    
    useEffect(() => {
            observer.observe(ref.current);
        
            return () => {
              observer.disconnect();
            };
          }, [ref, observer]);

          if(isIntersecting){
            if(ref.current.style?.animation === undefined || ref.current.style?.animation === null || ref.current.style?.animation === ""){
                ref.current.style.animation = "abt-slide-up-text .5s ease-in-out 0.1s forwards";
            }
          }
        
          return isIntersecting;
    }


    return(
        <div className='abt-w-e-container-grid'>

            <div ref={ref99} className={'abt-w-e-t-' + sufixo}>{language === "pt" ? "Experiência Profissional":"Working Experience"}</div>

            {
              language === "pt" ? 

              <div className={'abt-w-e-content-' + sufixo}>
                <div className='abt-w-e-r-1'>
                      <div ref={ref1} className={'abt-w-e-l1' + sufixo} style={{opacity:0}}><b>Designer Gráfico</b></div>
                      <div ref={ref2} className={'abt-w-e-l2' + sufixo} style={{opacity:0}}><i>Agosto 2025 - Presente</i></div>
                      <div ref={ref3} className={'abt-w-e-l3' + sufixo} style={{opacity:0}}><b>Scape</b>, Rio Meão</div>
                  </div>
                <div className='abt-w-e-r-2'>
                      <div ref={ref4} className={'abt-w-e-l4' + sufixo} style={{opacity:0}}><b>Designer Gráfico</b></div>
                      <div ref={ref5} className={'abt-w-e-l5' + sufixo} style={{opacity:0}}><i>Abril 2024 - Março 2025</i></div>
                      <div ref={ref6} className={'abt-w-e-l6' + sufixo} style={{opacity:0}}><b>Alphanna</b>, Porto</div>
                      <div ref={ref7} className={'abt-w-e-l7' + sufixo} style={{opacity:0}}>Funções:</div>
                      <div ref={ref8} className={'abt-w-e-l8' + sufixo} style={{opacity:0}}>&#9702; Criação e desenvolvimento de marcas;</div>
                      <div ref={ref9} className={'abt-w-e-l9' + sufixo} style={{opacity:0}}>&#9702; Design de embalagens e rótulos;</div>
                      <div ref={ref10} className={'abt-w-e-l10' + sufixo} style={{opacity:0}}>&#9702; Gestão de redes sociais;</div>
                      <div ref={ref11} className={'abt-w-e-l11' + sufixo} style={{opacity:0}}>&#9702; Coordenação de equipas criativas;</div>
                      <div ref={ref12} className={'abt-w-e-l12' + sufixo} style={{opacity:0}}>&#9702; Acompanhamento de projetos para clientes;</div>
                      <div ref={ref13} className={'abt-w-e-l13' + sufixo} style={{opacity:0}}>&#9702; Captação e edição fotográfica;</div>
                  </div>
                  <div className='abt-w-e-r-3'>
                      <div ref={ref14} className={'abt-w-e-l14' + sufixo} style={{opacity:0}}><b>Designer Gráfico</b></div>
                      <div ref={ref15} className={'abt-w-e-l15' + sufixo} style={{opacity:0}}><i>Janeiro 2016 - Março 2024</i></div>
                      <div ref={ref16} className={'abt-w-e-l16' + sufixo} style={{opacity:0}}><b>Outside The Box</b>, São João da Madeira</div>
                      <div ref={ref17} className={'abt-w-e-l17' + sufixo} style={{opacity:0}}>Funções:</div>
                      <div ref={ref18} className={'abt-w-e-l18' + sufixo} style={{opacity:0}}>&#9702; Criação de identidades visuais;</div>
                      <div ref={ref19} className={'abt-w-e-l19' + sufixo} style={{opacity:0}}>&#9702; Design gráfico para suportes diversos offline e online;</div>
                      <div ref={ref20} className={'abt-w-e-l20' + sufixo} style={{opacity:0}}>&#9702; Gestão de redes sociais: </div>
                      <div ref={ref21} className={'abt-w-e-l21' + sufixo} style={{opacity:0}}>&#9702; Planeamento, criação de conteúdos visuais, copy e meta ads;</div>
                      <div ref={ref22} className={'abt-w-e-l22' + sufixo} style={{opacity:0}}>&#9702; Apoio à produção gráfica;</div>
                      <div ref={ref23} className={'abt-w-e-l23' + sufixo} style={{opacity:0}}>&#9702; Captação e edição fotográfica;</div>
                  </div>
                  <div className='abt-w-e-r-4'>
                      <div ref={ref24} className={'abt-w-e-l24' + sufixo} style={{opacity:0}}>Outubro 2015 - Janeiro 2016</div>
                      <div ref={ref25} className={'abt-w-e-l25' + sufixo} style={{opacity:0}}>Designer Gráfico</div>
                      <div ref={ref26} className={'abt-w-e-l26' + sufixo} style={{opacity:0}}>Amazing Field, <span>Canedo</span></div>
                  </div>
                  <div className='abt-w-e-r-5'>
                      <div ref={ref27} className={'abt-w-e-l27' + sufixo} style={{opacity:0}}>Junho 2012 - Setembro 2012</div>
                      <div ref={ref28} className={'abt-w-e-l28' + sufixo} style={{opacity:0}}>Designer de Calçado - Estágio</div>
                      <div ref={ref29} className={'abt-w-e-l29' + sufixo} style={{opacity:0}}>Project ID, <span>Arrifana</span></div>
                  </div>
              </div>

              :

              <div className={'abt-w-e-content-' + sufixo}>
                <div className='abt-w-e-r-1'>
                    <div ref={ref1} className={'abt-w-e-l1' + sufixo} style={{opacity:0}}><b>Graphic Designer</b></div>
                      <div ref={ref2} className={'abt-w-e-l2' + sufixo} style={{opacity:0}}><i>August 2025 - Present</i></div>
                      <div ref={ref3} className={'abt-w-e-l3' + sufixo} style={{opacity:0}}><b>Scape</b>, Rio Meão</div>
                      </div>
                <div className='abt-w-e-r-2'>
                      <div ref={ref4} className={'abt-w-e-l4' + sufixo} style={{opacity:0}}><b>Graphic Designer</b></div>
                      <div ref={ref5} className={'abt-w-e-l5' + sufixo} style={{opacity:0}}><i>April 2024 - March 2025</i></div>
                      <div ref={ref6} className={'abt-w-e-l6' + sufixo} style={{opacity:0}}><b>Alphanna</b>, Porto</div>
                      <div ref={ref7} className={'abt-w-e-l7' + sufixo} style={{opacity:0}}>Primary functions:</div>
                      <div ref={ref8} className={'abt-w-e-l8' + sufixo} style={{opacity:0}}>&#9702; Brand creation and development;</div>
                      <div ref={ref9} className={'abt-w-e-l9' + sufixo} style={{opacity:0}}>&#9702; Packaging and label design;</div>
                      <div ref={ref10} className={'abt-w-e-l10' + sufixo} style={{opacity:0}}>&#9702; Social media management;</div>
                      <div ref={ref11} className={'abt-w-e-l11' + sufixo} style={{opacity:0}}>&#9702; Creative teams coordination;</div>
                      <div ref={ref12} className={'abt-w-e-l12' + sufixo} style={{opacity:0}}>&#9702; Project monitoring for clients;</div>
                      <div ref={ref13} className={'abt-w-e-l13' + sufixo} style={{opacity:0}}>&#9702; Photography and editing;</div>
                  </div>
                  <div className='abt-w-e-r-3'>
                      <div ref={ref14} className={'abt-w-e-l14' + sufixo} style={{opacity:0}}><b>Graphic Designer</b></div>
                      <div ref={ref15} className={'abt-w-e-l15' + sufixo} style={{opacity:0}}><i>January  2016 - March 2024</i></div>
                      <div ref={ref16} className={'abt-w-e-l16' + sufixo} style={{opacity:0}}><b>Outside The Box</b>, São João da Madeira</div>
                      <div ref={ref17} className={'abt-w-e-l17' + sufixo} style={{opacity:0}}>Primary functions:</div>
                      <div ref={ref18} className={'abt-w-e-l18' + sufixo} style={{opacity:0}}>&#9702; Visual identities creation & development;</div>
                      <div ref={ref19} className={'abt-w-e-l19' + sufixo} style={{opacity:0}}>&#9702; Graphic design for various offline and online supports;</div>
                      <div ref={ref20} className={'abt-w-e-l20' + sufixo} style={{opacity:0}}>&#9702; Social media management: </div>
                      <div ref={ref21} className={'abt-w-e-l21' + sufixo} style={{opacity:0}}>&#9702; Planning, visual content creation, copy and meta ads;</div>
                      <div ref={ref22} className={'abt-w-e-l22' + sufixo} style={{opacity:0}}>&#9702; Support for graphic production;</div>
                      <div ref={ref23} className={'abt-w-e-l23' + sufixo} style={{opacity:0}}>&#9702; Photography and editing;</div>
                  </div>
                  <div className='abt-w-e-r-4'>
                      <div ref={ref24} className={'abt-w-e-l24' + sufixo} style={{opacity:0}}>October 2015 - January 2016</div>
                      <div ref={ref25} className={'abt-w-e-l25' + sufixo} style={{opacity:0}}>Graphic Designer</div>
                      <div ref={ref26} className={'abt-w-e-l26' + sufixo} style={{opacity:0}}>Amazing Field, <span>Canedo</span></div>
                  </div>
                  <div className='abt-w-e-r-5'>
                      <div ref={ref27} className={'abt-w-e-l27' + sufixo} style={{opacity:0}}>June 2012 - September 2012</div>
                      <div ref={ref28} className={'abt-w-e-l28' + sufixo} style={{opacity:0}}>Shoe Designer Internship</div>
                      <div ref={ref29} className={'abt-w-e-l29' + sufixo} style={{opacity:0}}>Project ID, <span>Arrifana</span></div>
                  </div>
                </div>

              }

        </div>
    );
}